export enum EnvironmentNames {
  PROD = 'prod',
  UAT = 'uat',
  TEST = 'test',
  DEV = 'dev',
  LOCALDEV = 'local dev',
}